var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H70L80 10V80H0V0Z",
    fill: "#5490F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5555 58.6667H13.3333V18.6667H55.5555V25.3333L61.4888 20.8889H66.6666V56.4445H61.4888L55.5555 52V58.6667ZM17.7777 54.2222H51.111V43.1111L62.2221 51.4445V25.8889L51.111 34.2222V23.1111H17.7777V54.2222Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralZoom);
export default __webpack_public_path__ + "static/media/general_zoom.7cdf4c042bc672432aba78c3637beeba.svg";
export { ForwardRef as ReactComponent };